module.exports = __webpack_public_path__ + "img/多模型批量变更.edd56b69.svg";